/**
 * Is a repair order finished, i.e. is there nothing left for maintenance to
 * tell us about it?
 *
 * Asking a vendor "what is your ETA?" on a repair that is already Completed,
 * Closed or Cancelled is meaningless, so the maintenance-ping REQUEST buttons
 * are suppressed on those. Everything else — Open, Dispatched, Pending,
 * Deferred — is still live and still worth asking about.
 *
 * Existing chips are NOT suppressed by this: an outstanding request on a
 * finished repair order is information (someone asked, and it may still be
 * unanswered), and hiding it would erase the record from the UI.
 *
 * Measured against production (`safetynew.repairorder`, 2026 to date):
 * Completed 4225, Closed 3842, Cancelled 2458, Deferred 233, Pending 206,
 * Open 158, Draft 55, Dispatched 25. (`Draft` never reaches the ping surfaces —
 * the card query excludes it — and is treated as live anyway.)
 *
 * Matching is TRIMMED and CASE-INSENSITIVE: V1 writes this column
 * inconsistently cased, which is why the backend compares `UPPER(TRIM(...))`
 * in the same places.
 */
const FINISHED_STATUSES = new Set(['COMPLETED', 'CLOSED', 'CANCELLED']);

/**
 * True only for a status we positively recognise as terminal.
 *
 * FAILS OPEN on unknown/blank/undefined: a caller that could not determine the
 * status must not silently strip a working feature, and a ping raised against
 * a finished repair order is harmless (it simply never auto-clears).
 */
export const isFinishedRepairOrder = (status: string | null | undefined): boolean =>
  FINISHED_STATUSES.has((status || '').trim().toUpperCase());

export default isFinishedRepairOrder;
